import ACallingStatus from './index.vue';

ACallingStatus.install = app => {
  app.component(ACallingStatus.name, ACallingStatus);
};

export default ACallingStatus;
